module.exports = __webpack_public_path__ + "static/img/6.9781a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/6.png
// module id = XbMy
// module chunks = 1